module.exports = __webpack_public_path__ + "static/img/quiz-good@2x.23ab4101.png";